export default __webpack_public_path__ + "static/media/phoneEquip.ae0ab413.png";